exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-5c1410d8] .form-wrapper {\n  width: 100%;\n}\n.operator-wrapper[data-v-5c1410d8] {\n  margin: 5px;\n  width: 90px;\n  padding: 2px;\n  display: inline-block;\n}\n.lg-condition-wrapper[data-v-5c1410d8] {\n  margin: 5px;\n  width: 170px;\n  padding: 2px;\n  display: inline-block;\n}\n.error[data-v-5c1410d8] {\n  border: solid 1px red;\n}\n.md-button.remove-button[data-v-5c1410d8] {\n  min-width: 24px;\n  width: 24px;\n  height: 24px;\n  font-size: 12px;\n}\n.md-button.remove-button .md-icon.md-icon-font.md-theme-default[data-v-5c1410d8] {\n    color: red !important;\n}\n", ""]);

// exports
